// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element-variables.scss'

import '@/assets/css/base.scss';
import '@/assets/iconfont/iconfont.css';
import * as filters from './filters'

import { Cascader, Popup, Collapse, CollapseItem, Field, Sticky, NavBar, Swipe, SwipeItem, Loading, ImagePreview } from 'vant';
import 'vant/lib/cascader/style';
import 'vant/lib/popup/style';
import 'vant/lib/field/style';
import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
import 'vant/lib/nav-bar/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/loading/style';
import 'vant/lib/image-preview/style';
/* 滑动验证码 */
import SlideVerify from 'vue-monoplasty-slide-verify'
Vue.use(Cascader);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Sticky);
Vue.use(ElementUI);
Vue.use(SlideVerify)
Vue.use(NavBar)
Vue.use(Swipe);
Vue.use(SwipeItem)
Vue.use(Loading)
Vue.use(ImagePreview)
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
// 事件总线
Vue.prototype.$bus = new Vue()



// WEBPACK FOOTER //
// ./src/main.js